import { Divider } from "@chakra-ui/react";

interface OptionDividerProps {
  color: string;
}

export function OptionDivider({ color }: OptionDividerProps) {
  return <Divider bg={color} h="1px" opacity="0.3" />;
}
